<template>
    <v-card>
        <v-card-text>
            <v-form>
                <v-text-field
                        readonly
                        prepend-icon="short_text"
                        v-model="student.firstName"
                        label="First Name">
                </v-text-field>
                <v-text-field
                        readonly
                        prepend-icon="short_text"
                        v-model="student.middleName"
                        label="Middle Name">
                </v-text-field>
                <v-text-field
                        readonly
                        prepend-icon="short_text"
                        v-model="student.lastName"
                        label="Last Name">
                </v-text-field>
                <v-text-field
                        readonly
                        prepend-icon="phone"
                        value="(555) 555-5555"
                        label="Phone Number">
                </v-text-field>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="info"
                           @click="navigateToStudentHistory()">View Test History</v-btn>
                </v-card-actions>
            </v-form>
        </v-card-text>
    </v-card>

</template>

<script>
    import {Student} from "../state/models/Student";

    export default {
        name: "StudentDetail",
        data: function () {
            return {
                id: undefined,
                student: new Student()
            }
        },
        methods: {
            navigateToStudentHistory() {
                let options = {
                    name: 'test-history-chart',
                    query: {
                        studentId: this.id,
                    }
                };
                this.$router.push(options);
            }
        },
        mounted() {
            this.id = +this.$router.currentRoute.params['id'];
            this.$store.dispatch('getStudents', {ids: [this.id]})
                .then((sList) => {
                    console.debug(sList);
                    console.debug(this.id);
                    if (!sList || !sList.length) {
                        return Promise.reject('The student wasn\'t found');
                    }
                    this.student = sList[0];

                    this.$store.commit('setToolbarOptions', {
                        title: 'Student',
                        subTitle: this.student.getFullName(),
                        hideSearch: false,
                        backButtonRoute: {name: 'students'}
                    });
                });
        }
    }
</script>

<style scoped>

</style>
